// useLegacyUrlRewrite — Translates path-style URLs from before the
// SPA cut-over into the new hash form via `history.replaceState`.
// Runs once at AuthProvider mount, BEFORE React Router reads the
// hash, so bookmarked /license-orgs/<id>/audit?action=X URLs land
// on the matching React route with the query preserved.

import { useEffect } from 'react';

export function useLegacyUrlRewrite() {
  useEffect(() => {
    const { pathname, search, hash } = window.location;
    // Already has a hash? Nothing to do.
    if (hash && hash !== '#' && hash !== '#/') return;
    if (pathname === '/' || pathname === '/index.html' || pathname === '/app.html') {
      return;
    }
    const stripped = pathname.replace(/\/+$/, '');
    if (!stripped) return;
    const newHash = `#${stripped}${search ?? ''}`;
    history.replaceState(null, '', `/${newHash}`);
  }, []);
}
